import React from 'react';

import { getCompanyUserCoreRequest } from '@vyce/core/src/api/companies';

import { EmployeePreview } from '../../payroll/components/EmployeePreview';

// Declared at module level on purpose: EmployerRoute renders via
// React.createElement(component, props), so an inline arrow in `component={}` would be a new
// component type on every render and would remount the whole preview.
export const UserManagementUserPreview: React.FC = () => (
  <EmployeePreview getUserRequest={getCompanyUserCoreRequest} />
);
